import go from './module';
import { Feature } from '@common-stack/server-core';

export default new Feature(go);
